<script>
import { combustionFactors as _API_ } from "./api-calls";
import { combustionCategories as _COMBUSTION_CATEGORIES_ } from "./api-calls";
import { isoSectors as _ISO_SECTORS_ } from "./api-calls";
import { mobilityTypes as _MOBILITY_TYPES_ } from "./api-calls";

export default {
    data() {
        return {
            ROW_WIDTH: '97%',

            data: [],
            combustionCategories: [],
            mobilityTypes: [],
            
            selectedLanguage: 'en',
            languages: [
                { value: 'en', text: 'EN' },
                { value: 'tr', text: 'TR' },
            ],
            
            selectedSector: null,
            isoSectors: [{value: null, text: this.$t('carbon-admin.misc.no_sector')}],
            
            selectedUpdatePopupTab: 'main',
            updatePopupTabs: [
                { value: 'main', text: this.$t('carbon-admin.misc.main') },
                { value: 'co2', text: 'CO2' },
                { value: 'ch4', text: 'CH4' },
                { value: 'n2o', text: 'N2O' },
            ],

            headers: [
                {
                    key: '#',
                    in: 'index',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'name',
                    in: 'text_data',
                    style: {
                        'flex': 2,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'description',
                    in: 'text_data',
                    style: {
                        'flex': 5,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'ncv_default',
                    in: 'main_data',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'ncv_lower',
                    in: 'main_data',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'ncv_upper',
                    in: 'main_data',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    }
                },
            ],

            createData: undefined,
            editData: undefined,
        }
    },

    computed: {
        nullishGenericEntity() {
            return {
                "main_data": {"id": null},
                "text_data": {
                    "en": { "name": null }, 
                    "tr": { "name": null }
                }
            }
        }
    },

    watch: {
        async selectedSector() {
            await this.fetchRequest();
        }
    },

    async mounted() {
        await this.fetchCombustionCategoriesRequest();
        await this.fetchIsoSectorsRequest();
        await this.fetchMobilityTypesRequest();
        await this.fetchRequest();
    },

    methods: {
        async fetchCombustionCategoriesRequest() {
            await _COMBUSTION_CATEGORIES_.fetch()
                .then(res => {
                    this.combustionCategories = res.data;
                })
        },
        
        async fetchIsoSectorsRequest() {
            await _ISO_SECTORS_.fetch()
                .then(res => {
                    for (let index = 0; index < res.data.length; index++) {
                        const element = res.data[index];
                        this.isoSectors.push({
                            value: element.main_data.id,
                            text: element.text_data[this.selectedLanguage].name
                        });
                    }
                })
        },
        
        async fetchMobilityTypesRequest() {
            await _MOBILITY_TYPES_.fetch()
                .then(res => {
                    this.mobilityTypes = res.data;
                })
        },
        
        async fetchRequest() {
            await _API_.fetch(this.selectedSector)
                .then(res => {
                    this.data = res.data;
                })
        },
        
        async createRequest() {
            const params = {
                id: undefined,
                body: {
                    ...this.createData,
                    sectors: this.isoSectors.map(x => x.value)
                }
            };

            await _API_.create(params)
                .then(res => {
                    this.data.push(
                        {
                            main_data: {
                                id: res.data.value,
                                created_by: this.$user.user_id,
                                created_on: new Date(),
                                ...this.createData.main_data
                            },
                            text_data: this.createData.text_data
                        }
                    );

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async updateRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: this.editData
            };
            
            await _API_.update(params)
                .then(res => {
                    this.editData.updated_by = this.$user.user_id,
                    this.editData.updated_on = new Date(),
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async deleteRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: undefined
            };
            await _API_.delete(params.id)
                .then(res => {
                    this.editData.main_data.is_deleted = true;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.$refs.editPopup.startHideProcess();
                })
        },

        async handleClickCreate() {
            await this.setupCreateData();
            this.$refs.createPopup.openPopup();
        },

        async setupCreateData() {
            this.createData = {
                main_data: {
                    combustion_category_id: null,
                    ncv_default: null,
                    ncv_lower: null,
                    ncv_upper: null
                },
                text_data: {
                    tr: {
                        name: null,
                        description: null,
                    },
                    en: {
                        name: null,
                        description: null,
                    },
                },
                co2_data: {
                    sector_id: null,
                    mobility_type_id: null,
                    val_default: null,
                    val_lower: null,
                    val_upper: null
                },
                ch4_data: {
                    sector_id: null,
                    mobility_type_id: null,
                    val_default: null,
                    val_lower: null,
                    val_upper: null
                },
                n2o_data: {
                    sector_id: null,
                    mobility_type_id: null,
                    val_default: null,
                    val_lower: null,
                    val_upper: null
                },
            };
        },

        async handleClickEdit(item) {
            await this.setupEditData(item);
            this.$refs.editPopup.openPopup();
        },

        async setupEditData(item) {
            this.editData = item;
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col main-frame">
        <tab-selector 
            :options="languages" 
            :selectedTab="selectedLanguage" 
            @select-tab="($event) => selectedLanguage = $event.value"
        />
        
        <tab-selector 
            :options="isoSectors" 
            :selectedTab="selectedSector" 
            :customStyle="{
                'width': '100%',
                'border-radius': '.5em'
            }"
            @select-tab="($event) => selectedSector = $event.value"
        />

        <div class="table small-box-shadow">
            <div class="table-row headers">
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    {{ $t(`carbon-admin.headers.${h.key}`) }}
                </div>
            </div>
    
            <div v-for="(item, idx) in data" :key="idx"
                v-show="!item.main_data.is_deleted"
                class="table-row values"
                @click="handleClickEdit(item)"
            >
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    <span v-if="h.in === 'index'">
                        {{ idx+1 }}
                    </span>
                    <span v-else-if="h.in === 'text_data'">
                        {{ item.text_data[selectedLanguage][h.key] }}
                    </span>
                    <span v-else>
                        {{ item.main_data[h.key] }}
                    </span>
                </div>
            </div>
        </div>

        <div class="flex-all-centered-row" style="justify-content: flex-end;">
            <button class="sust-btn sust-btn-green"
                @click="handleClickCreate()"
            >
                {{ $t('misc.create-new') }}
            </button>
        </div>

        <sust-popup ref="createPopup"
            size="md"
            :header="false"
            @ok="createRequest()"
            @onHide="() => {
                createData = undefined;
                selectedUpdatePopupTab = 'main'
            }"
        >
            <div v-if="createData" 
                class="flex-all-centered-col"
            >
                <tab-selector 
                    :options="updatePopupTabs" 
                    :selectedTab="selectedUpdatePopupTab" 
                    @select-tab="($event) => selectedUpdatePopupTab = $event.value"
                />

                <div v-if="selectedUpdatePopupTab === 'main'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.name') }} (EN)
                        </div>
                        <input class="sust-input-field" 
                            style="width: 100%;"
                            type="text" 
                            v-model="createData.text_data.en.name"
                        >
                    </div>
    
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.name') }} (TR)
                        </div>
                        <input class="sust-input-field" 
                            style="width: 100%;"
                            type="text" 
                            v-model="createData.text_data.tr.name"
                        >
                    </div>
    
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.description') }} (EN)
                        </div>
                        <textarea class="sust-input-field"
                            style="width: 100%;"
                            v-model="createData.text_data.en.description"
                            rows="3"
                        ></textarea>
                    </div>
    
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.description') }} (TR)
                        </div>
                        <textarea class="sust-input-field"
                            style="width: 100%;"
                            v-model="createData.text_data.tr.description"
                            rows="3"
                        ></textarea>
                    </div>
    
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.combustion_category') }}
                            </div>
                            <select v-model="createData.main_data.combustion_category_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...combustionCategories]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ncv_default') }}
                            </div>
                            <input v-model="createData.main_data.ncv_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ncv_lower') }}
                            </div>
                            <input v-model="createData.main_data.ncv_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ncv_upper') }}
                            </div>
                            <input v-model="createData.main_data.ncv_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>

                <div v-else-if="selectedUpdatePopupTab === 'co2'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.mobility_type') }}
                            </div>
                            <select v-model="createData.co2_data.mobility_type_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...mobilityTypes]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.co2_default') }}
                            </div>
                            <input v-model="createData.co2_data.val_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.co2_lower') }}
                            </div>
                            <input v-model="createData.co2_data.val_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.co2_upper') }}
                            </div>
                            <input v-model="createData.co2_data.val_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>
                
                <div v-else-if="selectedUpdatePopupTab === 'ch4'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.mobility_type') }}
                            </div>
                            <select v-model="createData.ch4_data.mobility_type_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...mobilityTypes]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ch4_default') }}
                            </div>
                            <input v-model="createData.ch4_data.val_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ch4_lower') }}
                            </div>
                            <input v-model="createData.ch4_data.val_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ch4_upper') }}
                            </div>
                            <input v-model="createData.ch4_data.val_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>
                
                <div v-else-if="selectedUpdatePopupTab === 'n2o'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.mobility_type') }}
                            </div>
                            <select v-model="createData.n2o_data.mobility_type_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...mobilityTypes]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.n2o_default') }}
                            </div>
                            <input v-model="createData.n2o_data.val_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.n2o_lower') }}
                            </div>
                            <input v-model="createData.n2o_data.val_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.n2o_upper') }}
                            </div>
                            <input v-model="createData.n2o_data.val_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </sust-popup>
        
        <sust-popup ref="editPopup"
            size="md"
            :header="false"
            @ok="updateRequest()"
            @onHide="() => {
                editData = undefined;
                selectedUpdatePopupTab = 'main'
            }"
        >
            <div v-if="editData" 
                class="flex-all-centered-col"
            >
                <tab-selector 
                    :options="updatePopupTabs" 
                    :selectedTab="selectedUpdatePopupTab" 
                    @select-tab="($event) => selectedUpdatePopupTab = $event.value"
                />

                <div v-if="selectedUpdatePopupTab === 'main'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.name') }} (EN)
                        </div>
                        <input class="sust-input-field" 
                            style="width: 100%;"
                            type="text" 
                            v-model="editData.text_data.en.name"
                        >
                    </div>
    
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.name') }} (TR)
                        </div>
                        <input class="sust-input-field" 
                            style="width: 100%;"
                            type="text" 
                            v-model="editData.text_data.tr.name"
                        >
                    </div>
    
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.description') }} (EN)
                        </div>
                        <textarea class="sust-input-field"
                            style="width: 100%;"
                            v-model="editData.text_data.en.description"
                            rows="3"
                        ></textarea>
                    </div>
    
                    <div class="flex-all-centered-col"
                        style="margin: .35em 0;"
                    >
                        <div style="font-weight: bold;">
                            {{ $t('carbon-admin.headers.description') }} (TR)
                        </div>
                        <textarea class="sust-input-field"
                            style="width: 100%;"
                            v-model="editData.text_data.tr.description"
                            rows="3"
                        ></textarea>
                    </div>
    
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.combustion_category') }}
                            </div>
                            <select v-model="editData.main_data.combustion_category_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...combustionCategories]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ncv_default') }}
                            </div>
                            <input v-model="editData.main_data.ncv_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ncv_lower') }}
                            </div>
                            <input v-model="editData.main_data.ncv_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ncv_upper') }}
                            </div>
                            <input v-model="editData.main_data.ncv_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>

                <div v-else-if="selectedUpdatePopupTab === 'co2'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.mobility_type') }}
                            </div>
                            <select v-model="editData.co2_data.mobility_type_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...mobilityTypes]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.co2_default') }}
                            </div>
                            <input v-model="editData.co2_data.val_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.co2_lower') }}
                            </div>
                            <input v-model="editData.co2_data.val_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.co2_upper') }}
                            </div>
                            <input v-model="editData.co2_data.val_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>
                
                <div v-else-if="selectedUpdatePopupTab === 'ch4'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.mobility_type') }}
                            </div>
                            <select v-model="editData.ch4_data.mobility_type_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...mobilityTypes]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ch4_default') }}
                            </div>
                            <input v-model="editData.ch4_data.val_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ch4_lower') }}
                            </div>
                            <input v-model="editData.ch4_data.val_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.ch4_upper') }}
                            </div>
                            <input v-model="editData.ch4_data.val_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>
                
                <div v-else-if="selectedUpdatePopupTab === 'n2o'"
                    class="flex-all-centered-col"
                >
                    <div class="flex-all-centered-row"
                        style="margin: .35em 0;"
                    >
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.mobility_type') }}
                            </div>
                            <select v-model="editData.n2o_data.mobility_type_id"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                                <option v-for="value in [nullishGenericEntity, ...mobilityTypes]"
                                    :key="value.main_data.id || null"
                                    :value="value.main_data.id || null"
                                >
                                    <span v-if="value">
                                        {{ value.text_data[selectedLanguage].name }}
                                    </span>
                                    <span v-else>
                                        {{ value }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.n2o_default') }}
                            </div>
                            <input v-model="editData.n2o_data.val_default"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.n2o_lower') }}
                            </div>
                            <input v-model="editData.n2o_data.val_lower"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                        <div class="flex-all-centered-col">
                            <div style="font-weight: bold;">
                                {{ $t('carbon-admin.headers.n2o_upper') }}
                            </div>
                            <input v-model="editData.n2o_data.val_upper"
                                type="number" min="0"
                                class="sust-input-field"
                                :style="{
                                    'width': ROW_WIDTH,
                                    'text-align': 'center'
                                }"
                            >
                        </div>
                    </div>
                </div>
            </div>

            <template #footer="{ hide }">
                <div class="flex-all-centered-row"
                    style="justify-content: space-between; padding: .5em;"
                >
                    <button class="sust-btn sust-btn-red"
                        @click="() => {
                            $refs.deletePopup.openPopup()
                        }"
                    >
                        {{ $t('misc.delete') }}
                    </button>

                    <div class="flex-all-centered-row"
                        style="justify-content: flex-end;"
                    >
                        <button class="sust-btn sust-btn-red"
                            @click="hide()"
                        >
                            {{ $t('misc.cancel') }}
                        </button>
                        <button class="sust-btn sust-btn-green"
                            style="margin-left: 1em;"
                            @click="() => {
                                updateRequest(); 
                                hide();
                            }"
                        >
                            {{ $t('misc.save') }}
                        </button>
                    </div>
                </div>
            </template>
        </sust-popup>

        <sust-popup ref="deletePopup"
            size="sm"
            :title="$t('carbon-admin.titles.delete')"
            @ok="deleteRequest()"
        >
            {{ $t('carbon-admin.warnings.delete') }}
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
@import "../../../assets/css/carbon-admin-page.scss";
</style>